import dayjs from "dayjs";
import { makeAutoObservable } from "mobx";
import construct from "../utils/construct";
import persist from "../utils/persist";

// eslint-disable-next-line
let _rootStore;

const defaultProperties = {
	/** @type {Record<string, unknown>[]} */
	lists: [],
	/** @type {string} */
	currentListId: null,
	currentDate: dayjs().startOf("month").toDate(),
};

export default class EconomosStore {
	constructor(rootStore) {
		construct(this, defaultProperties);
		_rootStore = rootStore;

		makeAutoObservable(this);
		persist(this, "economosStore");
	}

	reset() {
		construct(this, defaultProperties);
	}

	hasSomeLists() {
		return this.lists.length > 0;
	}

	selectedListIsUnknown() {
		const found = this.lists.find((_list) => _list.id === this.getSelectedListId());

		return !found;
	}

	getSelectedListId() {
		return this.currentListId;
	}

	getIsSelectedtListEmpty() {
		return !this.getSelectedListId();
	}

	setLists(lists) {
		this.lists = lists;
	}

	/**
	 * @param {string} listId
	 */
	setSelectedListId(listId) {
		if (!listId) return;
		if (typeof listId !== "string") return;

		this.currentListId = listId;
	}

	/**
	 * @param {number | "first" | "last"} idx
	 */
	setSelectedListByIdx(idx = 0) {
		let parsedIndex = idx;

		if (parsedIndex === "first") {
			parsedIndex = 0;
		} else if (parsedIndex === "last") {
			parsedIndex = this.lists.length - 1;
		}

		const list = this.lists[parsedIndex];
		if (!list?.id) return;

		this.setSelectedListId(list?.id);
	}

	/**
	 * @returns {Date}
	 */
	getCurrentDate() {
		return this.currentDate ?? this.resetCurrentDate();
	}

	getCurrentMonthAndYear() {
		const currentDate = dayjs(this.getCurrentDate());

		return {
			month: currentDate.month() + 1,
			year: currentDate.year(),
		};
	}

	isSameMonth({ date, useYear = false }) {
		const _date = dayjs(this.getCurrentDate());
		const _targetDate = dayjs(date);

		const isSameYear = useYear ? _date.isSame(_targetDate, "year") : true;
		const isSameMonth = _date.isSame(_targetDate, "month");

		return isSameYear && isSameMonth;
	}

	isFutureMonth({ date }) {
		const _date = dayjs(this.getCurrentDate());
		const _targetDate = dayjs(date);

		return _date.isAfter(_targetDate, "month");
	}

	changeCurrentDate({ month = 1 }) {
		const next = dayjs(this.currentDate).startOf("month").add(month, "month");
		this.currentDate = next.toDate();
	}

	setCurrentDate({ date }) {
		const nextDate = dayjs(date).startOf("month").toDate();
		this.currentDate = nextDate;
	}

	/**
	 * @returns {Date} The new current date.
	 */
	resetCurrentDate() {
		this.currentDate = dayjs().startOf("month").toDate();
		return this.currentDate;
	}
}
